<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon *ngIf="action === 'edit'" icon="edit-outline"></nb-icon>
        <nb-icon *ngIf="action !== 'edit'" icon="plus-outline"></nb-icon>
        <div *ngIf="action === 'edit'" class="ml-2" i18n>Editing Image Source</div>
        <div *ngIf="action === 'create'" class="ml-2" i18n>Creating Image Source</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>DRB Item Details</strong>
    <button
      nbButton
      outline
      status="info"
      shape="round"
      size="small"
      nbTooltip="More Info"
      i18n-nbTooltip
      style="margin-left: 430px"
      (click)="drbImageInfo(moreInfo)"
    >
      <nb-icon icon="info"></nb-icon>
    </button>
    <hr />
    <form #xliffForm="ngForm">
      <div class="row">
        <div class="col">
          <label i18n>ID<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <div class="input-box">
            <span class="prefix" *ngIf="action === 'create'">{{ prefix() }}</span>
            <input
              id="id"
              name="id"
              nbInput
              fullWidth
              style="width: 100%"
              #imageId="ngModel"
              [(ngModel)]="image.id"
              [disabled]="action === 'edit'"
              [pattern]="patternId"
              required
            />
            <span class="sufix" *ngIf="action === 'create'">_dmc</span>
          </div>
          <div *ngIf="imageId.errors?.pattern">
            <p class="error" i18n>ID not valid! ID allows only alphanumeric characters and underscore.</p>
          </div>
        </div>
      </div>
      <ng-template #moreInfo>
        <nb-card>
          <nb-card-header i18n>Upload image information</nb-card-header>
          <nb-card-body>
            <ul>
              <li i18n>Must be ZIP file</li>
              <li i18n>ZIP must contain .png/.jpg</li>
              <li i18n>Images must be inside density folders (drawable-mdpi - drawable-xxxhdpi)</li>
              <li i18n>Each image must be 200KB or smaller</li>
              <li i18n>The same filename must be used across ALL density versions/folders (ie. icon.png)</li>
            </ul>
          </nb-card-body>
          <nb-card-footer><button nbButton status="success" (click)="closeInfo()" i18n>OK</button></nb-card-footer>
        </nb-card>
      </ng-template>
      <br />
      <div class="row">
        <div class="col">
          <label i18n>Link<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <input
            id="location"
            name="location"
            nbInput
            fullWidth
            placeholder="Location"
            style="width: 100%"
            [(ngModel)]="image.location"
            #location="ngModel"
            [pattern]="patternLocation"
            required
          />
          <div *ngIf="location.errors?.pattern">
            <p class="error" i18n>Location not valid! Quotes (' ") are not allowed.</p>
          </div>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton class="ml-3" status="success" (click)="save()" [disabled]="!xliffForm.form.valid" i18n>
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
